var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "app flex-row align-middle bg-gray-50"
  }, [_c('Toast'), _c('div', {
    staticClass: "container flex relative justify-center h-screen items-center bg-gray-50 text-left"
  }, [_c('div', {
    staticClass: "flex-col w-2/5 justify-center"
  }, [_c('div', [_c('div', {
    staticClass: "max-w-xl mx-auto overflow-hidden"
  }, [_vm.announcement.length ? _c('VueSlickCarousel', {
    staticClass: "mb-0 custom-dots",
    attrs: {
      "arrows": false,
      "dots": true,
      "autoplay": true,
      "autoplaySpeed": 4000,
      "infinite": true,
      "slidesToShow": 1,
      "slidesToScroll": 1
    }
  }, _vm._l(_vm.announcement, function (item) {
    return _c('div', {
      key: item.id
    }, [_c('div', {
      staticClass: "bg-blue-50 text-blue-800 h-28 w-full px-3 py-3 rounded-md"
    }, [_c('div', {
      staticClass: "flex justify-start"
    }, [_c('div', {
      staticClass: "mr-2"
    }, [_c('svg', {
      staticClass: "w-6 h-6 text-blue-800 dark:text-white",
      attrs: {
        "aria-hidden": "true",
        "xmlns": "http://www.w3.org/2000/svg",
        "width": "24",
        "height": "24",
        "fill": "currentColor",
        "viewBox": "0 0 24 24"
      }
    }, [_c('path', {
      attrs: {
        "fill-rule": "evenodd",
        "d": "M2 12C2 6.477 6.477 2 12 2s10 4.477 10 10-4.477 10-10 10S2 17.523 2 12Zm9.408-5.5a1 1 0 1 0 0 2h.01a1 1 0 1 0 0-2h-.01ZM10 10a1 1 0 1 0 0 2h1v3h-1a1 1 0 1 0 0 2h4a1 1 0 1 0 0-2h-1v-4a1 1 0 0 0-1-1h-2Z",
        "clip-rule": "evenodd"
      }
    })])]), _c('div', {
      staticClass: "content-announcement"
    }, [_c('p', {
      staticClass: "font-semibold mb-1"
    }, [_vm._v(" " + _vm._s(item.title) + " ")]), _c('p', {
      staticClass: "mb-1"
    }, [_vm._v(" " + _vm._s(item.message) + " ")])])])])]);
  }), 0) : _vm._e()], 1), _vm._m(0), _c('div', {
    staticClass: "rounded-lg h-auto border shadow-md flex justify-center bg-white"
  }, [_c('div', {
    staticClass: "flex-col w-full justify-center"
  }, [_c('h4', {
    staticClass: "font-bold px-3 mt-4 mb-3"
  }, [_vm._v("Log in")]), _c('div', {
    staticClass: "mt-0 w-full px-3"
  }, [_c('label', {
    staticClass: "block w-full mb-2 text-sm font-medium text-gray-900",
    attrs: {
      "for": "email"
    }
  }, [_vm._v("Email")]), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: _vm.Form.email,
      expression: "Form.email"
    }],
    staticClass: "shadow-sm text-gray-500 bg-gray-50 p-2.5 w-full rounded-lg",
    class: _vm.errors.email || _vm.errors.correct_email_password ? 'bg-red-50 border-custom' : 'border',
    attrs: {
      "type": "email",
      "id": "email",
      "placeholder": "name@example.com",
      "autocomplete": "email",
      "required": ""
    },
    domProps: {
      "value": _vm.Form.email
    },
    on: {
      "input": [function ($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.Form, "email", $event.target.value);
      }, _vm.validateEmail]
    }
  }), _vm.errors.email ? _c('div', {
    staticClass: "text-red-500 text-sm mt-2"
  }, [_vm._v(_vm._s(_vm.errors.email))]) : _vm._e()]), _c('div', {
    staticClass: "mt-3 w-full px-3 relative"
  }, [_c('label', {
    staticClass: "block mb-2 text-sm font-medium text-gray-900",
    attrs: {
      "for": "password"
    }
  }, [_vm._v("Password")]), _vm.showPassword ? _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: _vm.Form.password,
      expression: "Form.password"
    }],
    staticClass: "shadow-sm text-gray-500 bg-gray-50 p-2.5 w-full rounded-lg",
    class: _vm.errors.password || _vm.errors.correct_email_password ? 'bg-red-50 border-custom' : 'border',
    attrs: {
      "type": "text",
      "placeholder": "Password",
      "required": ""
    },
    domProps: {
      "value": _vm.Form.password
    },
    on: {
      "input": [function ($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.Form, "password", $event.target.value);
      }, _vm.validatePassword]
    }
  }) : _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: _vm.Form.password,
      expression: "Form.password"
    }],
    staticClass: "shadow-sm text-gray-500 bg-gray-50 p-2.5 w-full rounded-lg",
    class: _vm.errors.password || _vm.errors.correct_email_password ? 'bg-red-50 border-custom' : 'border',
    attrs: {
      "type": "password",
      "placeholder": "Password",
      "required": ""
    },
    domProps: {
      "value": _vm.Form.password
    },
    on: {
      "input": [function ($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.Form, "password", $event.target.value);
      }, _vm.validatePassword]
    }
  }), !_vm.showPassword ? _c('span', {
    staticClass: "icon-eye",
    on: {
      "click": _vm.toggleShow
    }
  }, [_c('svg', {
    attrs: {
      "width": "14",
      "height": "14",
      "viewBox": "0 0 12 10",
      "fill": "none",
      "xmlns": "http://www.w3.org/2000/svg"
    }
  }, [_c('path', {
    attrs: {
      "d": "M0.5 5C0.5 4.9612 0.516005 4.86113 0.586554 4.69231C0.653822 4.53134 0.758302 4.3371 0.90084 4.12003C1.18576 3.68611 1.60426 3.18899 2.12311 2.71967C3.17053 1.77224 4.55575 1 6 1C7.44425 1 8.82947 1.77224 9.87689 2.71967C10.3957 3.18899 10.8142 3.68611 11.0992 4.12003C11.2417 4.3371 11.3462 4.53134 11.4134 4.69231C11.484 4.86113 11.5 4.9612 11.5 5C11.5 5.15567 11.4134 5.48848 11.1686 5.93527C10.9328 6.36553 10.5764 6.85308 10.1041 7.31097C9.16123 8.22514 7.78061 9 6 9C4.21939 9 2.83877 8.22514 1.8959 7.31097C1.42363 6.85308 1.06721 6.36553 0.831416 5.93527C0.586564 5.48848 0.5 5.15567 0.5 5ZM4.70892 7.0101C5.08776 7.28132 5.5371 7.42857 6 7.42857C6.62157 7.42857 7.21007 7.1637 7.63832 6.70487C8.06548 6.24719 8.3 5.63339 8.3 5C8.3 4.52705 8.16925 4.06219 7.92091 3.66396C7.67238 3.26545 7.31563 2.94938 6.89165 2.76122C6.46716 2.57283 5.99782 2.52288 5.54462 2.61947C5.09175 2.71598 4.68083 2.95319 4.36168 3.29513C4.04287 3.63671 3.82924 4.06787 3.74299 4.53249C3.65675 4.99702 3.70075 5.47885 3.87065 5.91833C4.04063 6.35799 4.33057 6.73924 4.70892 7.0101Z",
      "fill": this.errors.password || this.errors.correct_email_password ? '#ef4444' : '#6B7280',
      "stroke": this.errors.password || this.errors.correct_email_password ? '#ef4444' : '#6B7280'
    }
  })])]) : _c('span', {
    staticClass: "icon-eye",
    on: {
      "click": _vm.toggleShow
    }
  }, [_c('svg', {
    staticClass: "w-4 h-4 text-gray-500 dark:text-white",
    attrs: {
      "aria-hidden": "true",
      "xmlns": "http://www.w3.org/2000/svg",
      "width": "24",
      "height": "24",
      "fill": "none",
      "viewBox": "0 0 24 24"
    }
  }, [_c('path', {
    attrs: {
      "stroke": "currentColor",
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "2",
      "d": "M3.933 13.909A4.357 4.357 0 0 1 3 12c0-1 4-6 9-6m7.6 3.8A5.068 5.068 0 0 1 21 12c0 1-3 6-9 6-.314 0-.62-.014-.918-.04M5 19 19 5m-4 7a3 3 0 1 1-6 0 3 3 0 0 1 6 0Z"
    }
  })])]), _vm.errors.password ? _c('div', {
    staticClass: "text-red-500 text-sm mt-2"
  }, [_vm._v(_vm._s(_vm.errors.password))]) : _vm._e()]), _c('div', {
    staticClass: "mt-4 mb-5 w-full px-3 text-white text-right"
  }, [_c('span', {
    staticClass: "text-blue-700 text-right"
  }, [_c('router-link', {
    attrs: {
      "to": {
        path: '/forgotPassword'
      }
    }
  }, [_vm._v(" Forgot password? ")])], 1), _c('button', {
    staticClass: "w-full bg-blue-700 rounded-lg p-2.5 mt-3",
    attrs: {
      "disabled": _vm.isButtonDisabled
    },
    on: {
      "click": _vm.actionLogin
    }
  }, [_vm._v(" Log in "), _vm.isLoading ? _c('svg', {
    staticClass: "inline w-4 h-4 me-3 text-gray-200 animate-spin dark:text-gray-600",
    attrs: {
      "aria-hidden": "true",
      "role": "status",
      "viewBox": "0 0 100 101",
      "fill": "none",
      "xmlns": "http://www.w3.org/2000/svg"
    }
  }, [_c('path', {
    attrs: {
      "d": "M100 50.5908C100 78.2051 77.6142 100.591 50 100.591C22.3858 100.591 0 78.2051 0 50.5908C0 22.9766 22.3858 0.59082 50 0.59082C77.6142 0.59082 100 22.9766 100 50.5908ZM9.08144 50.5908C9.08144 73.1895 27.4013 91.5094 50 91.5094C72.5987 91.5094 90.9186 73.1895 90.9186 50.5908C90.9186 27.9921 72.5987 9.67226 50 9.67226C27.4013 9.67226 9.08144 27.9921 9.08144 50.5908Z",
      "fill": "currentColor"
    }
  }), _c('path', {
    attrs: {
      "d": "M93.9676 39.0409C96.393 38.4038 97.8624 35.9116 97.0079 33.5539C95.2932 28.8227 92.871 24.3692 89.8167 20.348C85.8452 15.1192 80.8826 10.7238 75.2124 7.41289C69.5422 4.10194 63.2754 1.94025 56.7698 1.05124C51.7666 0.367541 46.6976 0.446843 41.7345 1.27873C39.2613 1.69328 37.813 4.19778 38.4501 6.62326C39.0873 9.04874 41.5694 10.4717 44.0505 10.1071C47.8511 9.54855 51.7191 9.52689 55.5402 10.0491C60.8642 10.7766 65.9928 12.5457 70.6331 15.2552C75.2735 17.9648 79.3347 21.5619 82.5849 25.841C84.9175 28.9121 86.7997 32.2913 88.1811 35.8758C89.083 38.2158 91.5421 39.6781 93.9676 39.0409Z",
      "fill": "#1C64F2"
    }
  })]) : _vm._e()])])])])])])])], 1);
}
var staticRenderFns = [function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "flex justify-center"
  }, [_c('img', {
    staticClass: "mb-4",
    attrs: {
      "src": require("../../assets/img/gramedia_digital.png"),
      "alt": "admin@bootstrapmaster.com"
    }
  })]);
}]

export { render, staticRenderFns }